import { ReduxState } from '../../store';

export const selectHasNavigatedBack = (state: ReduxState): boolean =>
  state.navigationReducer.hasNavigatedBack;
